import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import TableCell from '@material-ui/core/TableCell';

const PreviewTableCellComponent = ({ data }) => (
  <TableCell
    style={{ padding: '10px', paddingRight: '0px' }}
  >
    <Typography dangerouslySetInnerHTML={{__html: (data || '').replace(/\\n/g, '<br />')}}></Typography>
  </TableCell>
);

PreviewTableCellComponent.propTypes = {
  data: PropTypes.string.isRequired,
};

export default PreviewTableCellComponent;
